import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LibGlobalVarService {

  static APP_NAME:string = "FINEX_APP_"; 
  static KEY_USER_INFO: string = `${LibGlobalVarService.APP_NAME}_USER_INFO`;
  static KEY_COM_INFO: string = `${LibGlobalVarService.APP_NAME}_COM_INFO`;
  static KEY_ALL_LANGS: string = LibGlobalVarService.APP_NAME + "available_langs";
  static KEY_ACTIVE_LANG: string = LibGlobalVarService.APP_NAME + "active_lang";
}
